import { render, staticRenderFns } from "./PCAcooperation.vue?vue&type=template&id=7f397187"
import script from "./PCAcooperation.vue?vue&type=script&lang=js"
export * from "./PCAcooperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports